<template>
    <div class="content_module">
        <div class="banner" id="banner" :style="{paddingBottom:banner_star.proportion,backgroundImage:banner_star.img_url}">
            <!-- <canvas id="canvas" :style="{backgroundImage:banner_star.img_url}"></canvas>  -->
            <div class="header_img">
            <div class="main_content">
                <p v-for="item in banner_star.items" v-html="item.title" :class="[item.class]" :ref="item.ref" :key="item.class"></p>
            </div>
                <div class="main_img" >
                <!-- <img :src="banner_star.src"> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'banner-star',
  props:["banner_star"],
  data () {
    return {
        autoTwinkleTimer: null,
        starNum: 0,
    }
  },
  mounted () {
    let self = this
    console.log(screen.width)
    if(screen.width>768){
        // self.initCanvas()
    }
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    for(let i in self.banner_star.items){
        let res = self.$refs[self.banner_star.items[i].ref]
        self.$scroll().reveal(res,{...fooReveal,delay:200 + 500*i})
    }
  },
  methods: {
    init () {
    },
    initCanvas () {

      let self = this
      if(self.banner_star.starNum){
        self.starNum=self.banner_star.starNum
      }
      var canvas = document.getElementById("canvas");
      var div1 = document.getElementById("banner");
      var cxt=canvas.getContext('2d');
      canvas.width = div1.offsetWidth
      canvas.height = div1.offsetHeight
      var starArr=[];  //2.多个星星对象
      for(var i=0;i<self.starNum;i++){
        var starObj={
          radius1:5+5*Math.random(),
          radius2:3*Math.random(),
          x:10+(canvas.width-20)*Math.random(),
          y:10+(canvas.height-20)*Math.random(),
          num:4,
          angle:360*Math.random(),
          changeAngle:-5+10*Math.random()
        }
        starArr.push(starObj);
      }
      self.startTwinkleTimer(cxt, starArr)
    },
    startTwinkleTimer (cxt, starArr) {
      let self = this
      var loop = function () {
        self.autoTwinkleTimer = setTimeout(() => {
          if(self && self.autoTwinkleTimer) {
            self.update(cxt, starArr)
            loop()
          }
        }, 40)
      }

      loop()
    },
    update(cxt, starArr){
      let self = this
      cxt.clearRect(0,0,canvas.width,canvas.height);
      for(var i=0;i<starArr.length;i++) {
        starArr[i].angle+=starArr[i].changeAngle;
        cxt.save();
        cxt.beginPath();
        cxt.translate(starArr[i].x, starArr[i].y);
        cxt.rotate(starArr[i].angle * Math.PI /360);
        cxt.scale(Math.sin(starArr[i].angle * Math.PI / 180), Math.sin(starArr[i].angle * Math.PI / 180));
        cxt.globalAlpha = Math.abs(Math.sin(starArr[i].angle * Math.PI / 180));
        self.drawStars(cxt,0,0,starArr[i].radius1,starArr[i].radius2,starArr[i].num);
        cxt.restore();
      }
    },
    drawStars(cxt,x,y,radius1,radius2,num){
      let self= this
      var angle = 360/(num*2);
      var arr = [];
      for(var i=0;i<num*2;i++){
        var starObj = {};
        if(i%2==0){
          starObj.x = x+radius1*Math.cos(i*angle*Math.PI/180);
          starObj.y = y+radius1*Math.sin(i*angle*Math.PI/180);
        }else{
          starObj.x = x+radius2*Math.cos(i*angle*Math.PI/180);
          starObj.y = y+radius2*Math.sin(i*angle*Math.PI/180);
        }
        arr.push(starObj);
      }

      cxt.beginPath();
      if(self.banner_star.color){
        cxt.fillStyle=self.banner_star.color
      }else{
        cxt.fillStyle="#fff";
      }
      cxt.moveTo(arr[0].x,arr[0].y);
      for(var i=1;i<arr.length;i++){
        cxt.lineTo(arr[i].x,arr[i].y);
      }
      cxt.closePath();
      cxt.fill();
    },
    stopTwinkleTimer () {
      let self = this
      if (!self.autoTwinkleTimer) {
        window.clearTimeout(self.autoTwinkleTimer)
      }
      self.autoTwinkleTimer = null
    }
  },
    beforeDestroy () {
        this.stopTwinkleTimer()
        let self = this
        self.$scroll().destroy()
    }
}
</script>

<style scoped>
@import '../../../static/css/common.css';

.banner{
    display: block;
    /* height: 0px; */
    /* padding-bottom:41.7%; */
    background-color: #f9fafc;
    padding-bottom: 23%;
    position:relative;
    width: 100%;
    z-index:99;
    background-size: 100% 100%;
}
.banner #canvas{
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    top:0;
    left:0;
    position:absolute;
}
.banner .main_content{
    position: relative;
    width:610px;
    text-align: center;
    /* height: 500px; */
    padding-left: 0px;
    margin-left: 0px;
    float: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.banner .header_img{
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
}
.banner .main_content .cont_bg{
    font-size:44px;
    width:100%;
    color:#ffffff;
    text-align:center;
    position:absolute;
    top:10%;
}
.banner .cont_mod{
    font-size:30px;
    width:100%;
    line-height: 65px;
    color:#ffffff;
    text-align:center;
    position:absolute;
    top: 33%;
}
.banner .cont_smt{
    font-size:22px;
    margin-left:25%;
    width:300px;
    line-height: 50px;
    color:#ffffff;
    text-align:center;
    position:absolute;
    top: 60%;
    border:0.5px solid #f4f4f4;
    border-radius:3%;
}
.banner .header_img .main_img{
    float: right;
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.banner .header_img .main_img img{
    width:100%;
}
</style>
<style scoped>
    @media screen and (max-width: 855px){
        .banner{
            /*min-width: 600px;*/
        }
        .banner .main_content{
            width:500px;
        }
        .banner .main_content .cont_bg{
            font-size:30px;
        }
        .banner .cont_mod{
            font-size:24px;
            line-height: 60px;
        }
        .banner .cont_smt{
            font-size:16px;
            width:260px;
            line-height: 35px;
            margin-top: 2%;
        }
    }
    @media screen and (max-width: 600px) {
        .banner .main_content .cont_bg{
            font-size:16px;
            width:100%;
            color:#ffffff;
            text-align:center;
            position:absolute;
            top:10%;
        }
        .banner .cont_mod{
            font-size:14px;
            line-height: 22px;
        }
        .banner .cont_smt{
            font-size: 12px;
            margin-left: 31%;
            width: 39%;
            line-height: 20px;
            top: 50%;
        }
    }
    @media screen and (max-width: 346px){
        .banner .cont_mod{
            font-size:14px;
            line-height: 30px;
            height: 30px;
        }
        .banner .cont_smt{
            font-size: 12px;
            margin-left: 29%;
            width: 43%;
            line-height: 21px;
            height: 21px;
            margin-top: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/banner_star.vue